<div class="container">
  <div class="row footer__main-row">
    <!-- Desktop logo -->
    <div class="col-12 col-lg-2 d-none d-lg-block order-3 order-lg-0">
      <div class="footer__logo-block text-right">
        <img
          class="footer__logo-img"
          src="/angular/browser/img/FP_LOGO_negyzetes.png"
          alt=""
        />
      </div>
    </div>

    <!-- Bal oldali oszlop: Magánszemélyeknek + Üzleti partnereknek -->
    <div class="col-7 col-lg-5 order-1 order-md-3 order-lg-2">
      <div class="container">
        <div class="row">
          <!-- Magánszemélyeknek -->
          <div
            class="footer__link-block footer__link-block--c2c col-12 col-md-6"
            *ngIf="menus[0]"
          >
            <span class="footer__link-block-header mb-3 pt-3 pt-lg-0">
              {{ menus[0].title }}
            </span>
            <ul class="footer__link-block-list">
              <li
                class="footer__link-block-list-item"
                *ngFor="let item of menus[0].items"
              >
                <a class="footer__link-block-link" [href]="item.url">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </div>

          <!-- Üzleti partnereknek -->
          <div
            class="footer__link-block footer__link-block--b2c col-12 col-md-6"
            *ngIf="menus[1]"
          >
            <span class="footer__link-block-header mb-3 pt-0 pt-sm-3 pt-lg-0">
              {{ menus[1].title }}
            </span>
            <ul class="footer__link-block-list">
              <li
                class="footer__link-block-list-item"
                *ngFor="let item of menus[1].items"
              >
                <a class="footer__link-block-link" [href]="item.url">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Jobb oldali oszlop: általános + jogi/egyéb -->
    <div class="col-5 col-lg-5 order-0 order-md-2 order-lg-3 pl-0 pl-lg-3">
      <div class="footer__link-block footer__link-block--all col pl-0 pl-lg-3">
        <div class="container-fluid pl-0 pl-lg-3">
          <div class="row">
            <!-- Mobil logo -->
            <div class="col-12 col-md-6 d-flex d-lg-none">
              <div class="footer__logo-block">
                <img
                  class="footer__logo-img footer__logo-img--mobile"
                  src="/angular/browser/img/FP_LOGO_negyzetes.png"
                  alt=""
                />
              </div>
            </div>

            <!-- 3. menü blokk (Foxpostról, Blog, stb.) -->
            <div class="col-12 col-md-6" *ngIf="menus[2]">
              <span
                class="footer__link-block-header mb-0 mb-lg-3 pt-0 pt-md-3 pt-lg-0"
              >
                &nbsp;
              </span>
              <ul class="footer__link-block-list pl-4 pl-lg-0">
                <li
                  class="footer__link-block-list-item"
                  *ngFor="let item of menus[2].items"
                >
                  <a class="footer__link-block-link" [href]="item.url">
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- 4. menü blokk (Impresszum, ÁSZF, stb.) -->
            <div
              class="col-12 col-md-6 offset-md-6 offset-lg-0"
              *ngIf="menus[3]"
            >
              <span class="footer__link-block-header d-none d-lg-block mb-3">
                &nbsp;
              </span>
              <ul class="footer__link-block-list pl-4 pl-lg-0">
                <li
                  class="footer__link-block-list-item"
                  *ngFor="let item of menus[3].items"
                >
                  <a class="footer__link-block-link" [href]="item.url">
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row footer__bottom-row">
    <div class="col-10 mx-auto footer__bottom-copyright">
      <div class="row desktop-logos-footer">
        <div class="col-2">©{{ currentYear }} foxpost.hu</div>
        <div class="col-10">
          <img
            class="img-fluid footer__bottom-eu-logo"
            src="https://foxpost.hu/img/logok_footer_1920px_2025_v1.png"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
      <div class="mobile-logos-footer">
        <div class="mx-auto">©{{ currentYear }} foxpost.hu</div>
        <div class="mx-auto">
          <img
            class="img-fluid footer__bottom-eu-logo"
            src="https://foxpost.hu/img/logok_footer_768px_2025_v1.png"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</div>
